// types
import { Report, ReportType, User, UserRoleWbg } from '../@types';
import { userRolesWbg } from '../@types/unions';

// i18
import { TFunction } from 'i18next';

// config
import { featureFlags } from '../config/featureFlags';

export interface GetReportsParams {
	t: TFunction;
	type?: ReportType;
	user: User | null;
}

export const getReports = ({ t, type, user }: GetReportsParams) => {
	const isUserRoleWbg = user && userRolesWbg.includes(user.role as UserRoleWbg);
	const hasIfrs = featureFlags['IFRS_GENERAL'] || (featureFlags['IFRS_TRIALS'] && isUserRoleWbg);

	const reports: Report[] = [
		{
			content: {
				children: t('reports.soe.content'),
			},
			GridProps: {
				xs: 12,
				md: 6,
				lg: hasIfrs ? 4 : 6,
			},
			IconCircleProps: {
				type: 'payment',
			},
			title: {
				children: t('soe'),
			},
			type: 'SOE',
		},
	];

	reports.push({
		content: {
			children: t('reports.fundFlow.content'),
		},
		GridProps: {
			xs: 12,
			md: 6,
			lg: hasIfrs ? 4 : 6,
		},
		IconCircleProps: {
			type: 'fundFlow',
		},
		title: {
			children: t('fundFlow'),
		},
		type: 'FUND_FLOW',
	});

	if (hasIfrs) {
		reports.push({
			content: {
				children: t('reports.ifr.content'),
			},
			GridProps: {
				xs: 12,
				md: 6,
				lg: 4,
			},
			IconCircleProps: {
				type: 'ifr',
			},
			title: {
				children: t('ifr'),
			},
			type: 'IFR',
		});
	}

	reports.push(
		{
			content: {
				children: t('reports.fundAllocation.content'),
			},
			fileName: 'report-fund-allocation',
			GridProps: {
				xs: 12,
				md: 6,
				lg: 4,
			},
			IconCircleProps: {
				type: 'account',
			},
			title: {
				children: t('fundAllocation'),
			},
			type: 'FUND_ALLOCATION',
		},
		{
			content: {
				children: t('reports.suppliersOverview.content'),
			},
			disabled: true,
			fileName: 'report-suppliers',
			GridProps: {
				xs: 12,
				md: 6,
				lg: 4,
			},
			IconCircleProps: {
				type: 'supplier',
			},
			title: {
				children: t('suppliersOverview'),
			},
			type: 'SUPPLIERS',
		},
		{
			content: {
				children: t('reports.beneficiariesOverview.content'),
			},
			disabled: true,
			fileName: 'report-beneficiaries',
			GridProps: {
				xs: 12,
				md: 6,
				lg: 4,
			},
			IconCircleProps: {
				type: 'individual',
			},
			title: {
				children: t('beneficiariesOverview'),
			},
			type: 'BENEFICIARIES',
		}
	);

	if (type) {
		const report = reports.find((r) => r.type === type);

		if (report) {
			return [report];
		}
	}

	return reports;
};
